<template>
  <div class="scenario-library-root">
    <div v-if="isLoading">
      <PleaseWait :bgColour="'#FFFFFF'" />
    </div>
    <div v-if="scenariosCount <= 0 && !isLoading" class="w-100 m-auto text-center">
      <h4 class="text-inherit">No available scenarios</h4>
      <div class="upload-new-btn m-3 mx-5 p-4" @click="showUploadPage">
        Upload New
      </div>
    </div>
    <div v-else class="scenario-library-body">
      <div class="grid-scroll">
        <div class="grid">
          <div
            v-for="scenario in scenarioObjects"
            v-bind:key="scenario.id"
            @click="onClick(scenario)"
          >
            <ScenarioMiniTile :scenario="scenario" />
          </div>
        </div>
      </div>
      <div class="row d-flex justify-content-center">
        <div
          class="pagination-wrapper col-12 d-flex justify-content-end mt-3 mr-5"
        >
          <template>
            <paginate
              v-model="page"
              :page-count="pageCount"
              :page-range="3"
              :margin-pages="2"
              :click-handler="clickCallback"
              :prev-text="'Prev'"
              :next-text="'Next'"
              :container-class="'pagination'"
              :page-class="'page-item'"
            />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ScenService from "@/services/scenarios.service";
import Paginate from "@/components/Paginate";
import ScenarioObject from "@/objects/ScenarioObject";
import NoContributed from "@/components/NoContributed";
import PleaseWait from "@/components/PleaseWait";
import ScenarioMiniTile from "@/components/ScenarioMiniTile";
import {PAGES} from "@/store/createForumPostStore";

export default {
  name: "ScenarioLibrary",
  components: {
    Paginate,
    NoContributed,
    PleaseWait,
    ScenarioMiniTile,
  },
  data: function () {
    return {
      isLoading: true,
      NUMBER_TO_GET: 9,
      PRIVACY_LEVELS: {
        PRIVATE: 0,
        ORGANISATION: 1,
        PUBLIC: 2,
      },
      pageCount: 0,
      page: 0,
      from: 0,
      to: 0,
      scenarios: [],
      scenariosCount: 0,
      pageNum: 0,
      scenarioObjects: [],
      isActive: false,
    };
  },
  methods: {
    getScenarios(startAt) {
      this.isLoading = true;
      this.isActive = true;
      ScenService.myUnpostedScenarios(startAt, this.NUMBER_TO_GET).then(
        (data) => {
          this.scenariosCount = data.total;
          this.scenarioObjects = [];
          for (let scenario in data.scenarios) {
            this.scenarioObjects.push(
              new ScenarioObject(data.scenarios[scenario])
            );
          }
          this.from = parseInt(data.from);
          this.to = parseInt(data.to);
          this.updatePageCount();
          this.isLoading = false;
        }
      );

      this.isActive = false;
    },
    clickCallback: function (pageNum) {
      this.isActive = true;

      window.scrollTo(0, 0);
      this.page = pageNum;
      pageNum = pageNum - 1;
      this.scenarioObjects = [];

      this.getScenarios(this.NUMBER_TO_GET * pageNum);
    },
    updatePageCount() {
      this.pageCount = Math.ceil(this.scenariosCount / this.NUMBER_TO_GET);
    },
    onClick(scenario) {
      this.$emit("on-click", scenario);
    },
    showUploadPage() {
      this.$store.commit("createForumPostStore/setCurrentPage", PAGES.Upload);
    }
  },

  beforeMount() {
    this.isLoading = true;
    this.getScenarios();
  },
};
</script>

<style scoped>
.scenario-library-root {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
}

.scenario-library-body {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
}

.grid-scroll {
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
}

.pagination-wrapper {
  flex-shrink: 0;
}

.grid {
  display: flex;
  flex-wrap: wrap;
}

.upload-new-btn {
  background: var(--isim-primary-light);
  color: var(--isim-secondary);
  border-radius: 8px;
  cursor: pointer;
}
</style>
